export const captureBrowserContext = () => ({
  userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
  viewportWidth: typeof window !== "undefined" ? window.innerWidth : 0,
  viewportHeight: typeof window !== "undefined" ? window.innerHeight : 0,
});
